import { createRouter, createWebHistory } from 'vue-router'
import HomeView1 from '../views/HomeView1.vue'
import HomeView2 from '../views/HomeView2.vue'
import BoxesView from '../views/BoxesView.vue'
import ContactView1 from '../views/ContactView1.vue'
import ContactView2 from '../views/ContactView2.vue'
import MainPages from '../views/MainPages.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView1,
    meta: { transition: 'slide' },
  },
  {
    path: '/2',
    name: 'home2',
    component: HomeView2,
    meta: { transition: 'slide' }
  },
  {
    path: '/boxes',
    name: 'boxes',
    component: BoxesView,
    meta: { transition: 'slide' }
  },
  {
    path: '/contact1',
    name: 'contact1',
    component: ContactView1,
    meta: { transition: 'slide' }
  },
  {
    path: '/contact2',
    name: 'contact2',
    component: ContactView2,
    meta: { transition: 'slide' }
  },
  {
    path: '/main',
    name: 'main',
    children: [
      { path: ':id',
        meta: {transition: 'slide'},
        component: MainPages,
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: "/"
  },
  /*
  {
    path: '/main/:id',
    name: 'main',
    component: MainPage,
    meta: { transition: 'slide' },
  },
  {
    path: '/main/00',
    name: 'maintoboxes',
    component: MainPage,
    meta: { transition: 'slide' },
    redirect: '/boxes',
  },
  {
    path: '/main/',
    name: 'mainentry',
    component: MainPage,
    meta: { transition: 'slide' },
    redirect: '/main/01',
  },
  {
    path: '/main/NaN',
    name: 'mainentrytrouble',
    component: MainPage,
    meta: { transition: 'slide' },
    redirect: '/main/01',
  }
    */
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export default router